<template>
	<label
		:class="{ 'validation-error-label': error, 'validation-valid-label': ! error }"
	>
		<slot></slot>
	</label>
</template>

<script>
	export default {
		props: {
			error: {
				type: Boolean,
				default: true
			}
		}
	}
</script>